import React from "react";
import { NavLink } from "react-router-dom";
import leftVilla from "../../images/home/leftVilaa.png";
import logo from "../../images/home/gt_logo.png";
import rightVilla from "../../images/home/rightVilla.png";
import trsutIcon from "../../images/home/trustIocn.png";
import luxuryIcon from "../../images/home/luxuryIocn.png";

const ComfortableVilla = () => {
  return (
    <section
      className=" text-white py-16 px-6 md:px-8  "
      style={{ maxWidth: "1440px", margin: "auto" }}
    >
      <div className="flex flex-col lg:flex-row  gap-4 items-center">
        {/* Left Side - Text & Image */}
        <div className="w-full lg:w-[60%]">
          <h3 className="md:text-xl text-[11px] uppercase  text-[#585858] poppins-medium max-md:mt-8">
            Welcome to Gir Glades
          </h3>
          <h1 className="text-4xl md:text-[46px] leading-[60px] font-bold text-[#672220] mt-2">
            The Perfect Amalgamation of Comfort & Luxury
          </h1>
          <div className="flex flex-col md:flex-row gap-8 ">
            <div className="mt-4">
              <img src={leftVilla} alt="left-villa" />
            </div>
            <div className="w-full md:w-[444px] mt-10">
              <p className="text-[#D1A752] text-xl font-normal mt-4">
                Experience the tranquility of living in the wilderness without
                compromising your dream holiday goals
              </p>
              <p className="text-[#585858] text-lg poppins-light  mt-6">
                Stay at Gir Glades, a unique luxury retreat located amidst the
                lush green forests of Sasan Gir. Discover an exceptional way to
                unwind in a luxurious villa equiped with every amenity you can
                think of, all without stepping out of nature’s embrace.
              </p>

              <ul className="mt-6 space-y-2">
                <li className="flex items-center text-[#212121] text-[14px] md:text-[22px] poppins-regular">
                  <span className=" mr-2 bg-[#620020] rounded-full">
                    <img
                      src={logo}
                      alt="Gir Glades"
                      className="h-6 min-w-[25px]"
                    />
                  </span>{" "}
                  Easy, Seamless Booking
                </li>
                <li className="flex items-center text-[#212121] text-[14px] md:text-[22px]  poppins-regular">
                  <span className=" mr-2 bg-[#620020] rounded-full">
                    {" "}
                    <img
                      src={logo}
                      alt="Gir Glades"
                      className="h-6 min-w-[25px]"
                    />
                  </span>{" "}
                  Handcrafted Boho Chic Interiors
                </li>
                <li className="flex items-center text-[#212121] text-[14px] md:text-[22px]  poppins-regular">
                  <span className=" mr-2 bg-[#620020] rounded-full">
                    {" "}
                    <img
                      src={logo}
                      alt="Gir Glades"
                      className="h-6 min-w-[25px]"
                    />
                  </span>{" "}
                  Elevated Design to Align With Gir’s Terrain
                </li>
                <li className="flex items-center text-[#212121] text-[14px] md:text-[22px]  poppins-regular">
                  <span className=" mr-2 bg-[#620020] rounded-full">
                    {" "}
                    <img
                      src={logo}
                      alt="Gir Glades"
                      className="h-6 min-w-[25px]"
                    />
                  </span>{" "}
                  Fully Customizable Experience
                </li>
              </ul>

              <NavLink to="/experience">
              <button className="mt-12 w-[229px] text-xl flex justify-center poppins-regular items-center h-[50px] border border-[#672220] text-[#672220] rounded-full hover:bg-[#672220] hover:text-white transition">
                + Explore More
              </button>
              </NavLink>
            </div>
          </div>
        </div>

        {/* Right Side - Images */}
        <div className="w-full lg:w-[40%] gap-10  md:gap-6">
          <div>
            <img
              src={rightVilla}
              alt="Luxury Woman"
              className="rounded-lg shadow-lg w-full  mt-6"
            />
          </div>

          <div className="flex justify-center mt-10 space-x-10">
            <div className="text-center shadow-lg shadow-[#00000033] flex flex-col justify-center w-[134px] h-[134px] rounded-full">
              <div className=" border   inline-flex items-center justify-center border-white ">
                <img src={trsutIcon} className="w-12 h-12" alt="Trusted Icon" />
              </div>
              <p className=" text-[#000000] text-lg poppins-regular">Trusted</p>
            </div>

            <div className="text-center shadow-lg shadow-[#00000033] flex flex-col justify-center w-[134px] h-[134px] rounded-full">
              <div className=" border   inline-flex items-center justify-center border-white ">
                <span className="text-3xl">
                  <img src={luxuryIcon} className="w-12 h-12" alt="luxury" />
                </span>
              </div>
              <p className="mt-2 text-[#000000] text-lg poppins-regular">
                Luxury
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Icons Section */}
    </section>
  );
};

export default ComfortableVilla;
